// extracted by mini-css-extract-plugin
export default {"wrapper":"LearningPathGroup_wrapper__sGyWu","title":"LearningPathGroup_title__ttQB7","desc":"LearningPathGroup_desc__9jEe+"};